import React, { FC, useState, useEffect } from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'

import ClickOutsideListener from '../../../common/components/ClickOutsideListener'
import Toast from '../../../common/components/Toast'

import Share from 'public/assets/svg/share.svg'
import ChainLink from 'public/assets/svg/chainlink.svg'
import TwitterX from 'public/assets/svg/twitter_x.svg'
import Pintinterest from 'public/assets/svg/pintinterest.svg'
import Facebook from 'public/assets/svg/facebook.svg'
import useClipboard from 'react-use-clipboard'
import styles from './styles'

const ShareMenu = ({ copyURL, url, className, tinyURL, id, svgColor, classes }) => {
    const [showMenu, setShowMenu] = useState(false)
    const [, setCopied] = useClipboard(tinyURL)

    useEffect(() => {
        if (tinyURL) {
            setCopied()
        }
    }, [setCopied, tinyURL])

    const onOpenMenu = () => {
        setShowMenu(!showMenu)
    }
    const onMenuItemLink = () => {
        setShowMenu(!showMenu)
        copyURL()
    }

    const onMenuItemTwitter = () => {
        setShowMenu(!showMenu)
        window.open(`https://www.twitter.com/share?url=${encodeURIComponent(url)}`, '_blank', 'noopener')
    }

    const onMenuItemPintInterest = () => {
        setShowMenu(!showMenu)
        window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}`, '_blank', 'noopener')
    }

    const onMenuItemFacebook = () => {
        setShowMenu(!showMenu)
        window.open(`https://www.facebook.com/share.php?u=${encodeURIComponent(url)}`, '_blank', 'noopener')
    }

    const clickOutside = () => {
        setShowMenu(false)
    }

    return (
        <>
            <ClickOutsideListener clickOutside={clickOutside}>
                <div className={`${classes.menuContainer} ${className || ''}`} data-testid="sharemenu">
                    <div className={classes.menuShareButtonContainer}>
                        <button
                            aria-expanded={showMenu}
                            aria-label="share options"
                            type="button"
                            className={`${classes.button} ${classes.menuShareButton}`}
                            onClick={onOpenMenu}
                        >
                            <img src={Share} />
                        </button>
                    </div>
                    <div className={`${classes.menu} ${showMenu ? classes.showMenu : classes.hideMenu}`}>
                        <div className={classes.iconRow}>
                            <div className={classes.iconCol} data-testid="chainlink">
                                <button
                                    aria-label="share link"
                                    type="button"
                                    className={`${classes.button} ${classes.menuButtonIcons}`}
                                    onClick={onMenuItemLink}
                                >
                                    <img src={ChainLink} />
                                </button>
                            </div>
                            <div className={classes.iconCol} data-testid="facebook">
                                <button
                                    aria-label="share facebook"
                                    type="button"
                                    className={`${classes.button} ${classes.menuButtonIcons}`}
                                    onClick={onMenuItemFacebook}
                                >
                                    <img src={Facebook} />
                                </button>
                            </div>
                        </div>
                        <div className={classes.iconRow}>
                            <div className={classes.iconCol} data-testid="twitter">
                                <button
                                    aria-label="share twitter"
                                    type="button"
                                    className={`${classes.button} ${classes.menuButtonIcons}`}
                                    onClick={onMenuItemTwitter}
                                >
                                    <img className={classes.twitterXIcon} src={TwitterX} />
                                </button>
                            </div>
                            <div className={classes.iconCol} data-testid="pinterest">
                                <button
                                    aria-label="share pinterest"
                                    type="button"
                                    className={`${classes.button} ${classes.menuButtonIcons}`}
                                    onClick={onMenuItemPintInterest}
                                >
                                    <img src={Pintinterest} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ClickOutsideListener>
            {tinyURL !== '' ? (
                <>
                    <Toast
                        text={tinyURL ? 'Link copied to clipboard' : "Link couldn't be copied"}
                        visible
                        position="bottom"
                        duration={2}
                        id={id}
                    />
                </>
            ) : null}
        </>
    )
}

ShareMenu.defaultProps = {
    url: undefined,
    className: undefined,
    svgColor: undefined,
}

export default compose(injectSheet(styles))(ShareMenu)
